import AccessibilityFlyout from './AccessibilityFlyout';
import { useNavigate } from 'react-router-dom';
import { mapEventToImage, importAll } from '../constants';
import AccessibilityModal from './AccessibilityModal';

export default function EventCard({ name, dateTime, venue, event}) {
    const images = importAll(require.context('../assets/eventImages', false, /\.(png|jpe?g|svg)$/));
    const imageKey = mapEventToImage[event.id];
    const navigate = useNavigate();
    const touchScreen = matchMedia('(pointer:coarse)').matches;
    const date = new Date(dateTime);
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric', 
        minute: 'numeric'
      };
    const dateTimeString = date.toLocaleTimeString('en-US', options);

    let price = '';
    if (event.ticket_price_min && event.ticket_price_max) {
        if (event.ticket_price_min === event.ticket_price_max) {
            price = `$${event.ticket_price_min}`
        } else {
            price = `$${event.ticket_price_min} - $${event.ticket_price_max}`
        }
    } else if (event.ticket_price_min) {
        price = `$${event.ticket_price_min}`
    } else {
        price = `$${event.ticket_price_max}`
    }
    if (price === '$0') {
        price = 'FREE'
    }

    const onClick = () => {
        console.log(venue.name);
        navigate(`/event/${event.id}`);
    }

    return (
        <div className="mb-1" id="card" style={{ cursor: "pointer"}} onClick={onClick}>
            <div className="row no-gutters">
                <div className="col-12 col-lg-6 my-auto">
                    <img src={images[imageKey]} style={{ borderRadius: 5, maxHeight:200 }} className="img-fluid h-100" alt=""/>
                </div>
                <div className="col-10 col-md-12 col-lg-6">
                    <div className="row px-2">
                        <div>
                            {event.category.map(category => {
                                return (
                                    <span key={category.id} id="white" style={{marginRight: 8}}>{category.name.toUpperCase()}</span>
                                );
                            })}
                        </div>
                        <h6 className="card-title mb-2">{name}</h6>
                        <p className="small no-margin">{dateTimeString}</p>
                        <p className="small">{venue.name}</p>
                        <div className="row justify-content-between my-auto">
                            <div className="col">
                                {touchScreen ? <AccessibilityModal info={venue.accessibility_info} venue={venue.name}/> : <AccessibilityFlyout info={venue.accessibility_info}/> } 
                            </div>
                            <div className="col text-end">
                                <div className="row align-self-center">
                                    <div className="col"> 
                                        <p className="vert-centered">{price}</p>  
                                    </div>
                                </div>                                 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}